import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Alert } from 'reactstrap';
import CapacityGauge from '../../components/CapacityGauge';
import Waitable from '../../components/Waitable';
// React DateRangePicker
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import './react_dates_overrides.css';


import { DateTimePicker } from 'react-widgets'

import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { encode } from "punycode";


moment.locale('en');
momentLocalizer();

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.state = {};
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  }
  render() {
    const { capacityEntries, start, end, onDateChange, date, settings } = this.props;
    const { focused } = this.state;

    let halfRadialGrid = capacityEntries.map(entry => {
      let terminal = entry[0];
      let info = entry[1];
      return (
        <Col key={terminal} xs="12" sm="6" md="6" lg="4" xl="3">
          <Card>
            <CardHeader>
              {terminal + " Capacity"}
            </CardHeader>
            <CardBody>
              <Row>
                <CapacityGauge
                  terminal={terminal}
                  start={start}
                  end={end}
                  capacity={info.avg}
                />
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    });

    return (
      <div className="animated fadeIn">

        {settings.get("data") ?
          <Alert className="animated slideInDown" color="success">
            <Waitable entities={[settings]}>
              <h4>{settings.get("data").bannerText}</h4>
            </Waitable>
          </Alert>
          : null}

        <Row className="pb-3">
          <Col md="6">


          <DateTimePicker
                            //value={moment(this.state.startDate).toDate()}
                            defaultValue={new Date()}
                            min={new Date()}
                            time={false}
                            onChange={onDateChange}
                        />

          </Col>
        </Row>
        <Row>
          {halfRadialGrid}
        </Row>

      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js